<template>
  <div class="a" v-loading="loading">
    <div class="item-left">
      <div id="c1"></div>
    </div>
    <div class="item-right">
      <div id="c2"></div>
    </div>
  </div>
</template>

<script>
import { Chart } from "@antv/g2";
import * as getData from "@/api/statistical-figure/index.js";
export default {
  data() {
    return {
      loading: true,
      chart: {},
      chart2: {}
    };
  },
  mounted() {
    this.chart = new Chart({
      container: "c1",
      autoFit: true,
      height: 300,
      width: 500,
      appendPadding: 30
    });
    this.chart2 = new Chart({
      container: "c2",
      autoFit: true,
      height: 300,
      width: 500,
      appendPadding: 30
    });

    getData.getCensusAll.r().then(res => {
      let data1 = [...res.discount.order_number, ...res.discount.refund];
      let data2 = [...res.discount.order_money, ...res.discount.refund_money];
      this.loading = false;
      this.chart = this.getChartData(data1, this.chart);
      this.chart2 = this.getChartData(data2, this.chart2);
    });
  },
  methods: {
    getChartData(data, chart) {
      chart.data(data);
      chart.scale({
        day: {
          range: [0, 1]
        },
        numberOf: {
          nice: true
        }
      });
      chart.coordinate({
        cfg: {
          radius: -1
        }
      });
      chart.tooltip({
        showCrosshairs: true,
        shared: true
      });
      chart.axis("numberOf", {
        label: {
          formatter: val => {
            return val;
          }
        }
      });
      chart
        .line()
        .position("day*numberOf")
        .color("typeName")
        .shape("smooth");
      chart.render();
      return chart;
    }
  }
};
</script>

<style lang="scss" scoped>
.a {
  background-color: #fff;
  width: 100%;
  display: flex;
  justify-content: space-around;
  .item-left,
  .item-right {
    width: calc(50%);
  }
}
</style>
